// app/frontend/components/ui/Drawers/DrawerNavigation.tsx
//
// What a drawer's content can ask of the drawer around it (#2500): open an
// event in place, so the header's back arrow can return to this drawer.
// Content rendered outside a drawer gets no provider, and callers fall back
// to visiting the page.
import { createContext, useContext } from 'react';

export interface DrawerNavigation {
  openEvent?: (event: { slug: string; name?: string }) => void;
}

const DrawerNavigationContext = createContext<DrawerNavigation>({});

export const DrawerNavigationProvider = DrawerNavigationContext.Provider;

export const useDrawerNavigation = () => useContext(DrawerNavigationContext);
